import { render } from "./BaseModal.vue?vue&type=template&id=0ceca2d4&scoped=true&ts=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=0ceca2d4&lang=scss&scoped=true"
import "./BaseModal.vue?vue&type=style&index=1&id=0ceca2d4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceca2d4"]])

export default __exports__